export default __webpack_public_path__ + "static/media/illi1.d873d5e9.png";